import React from 'react';
// MODULES
// COMPONENTS
import message from 'antd/lib/message';
import InvoiceList from '../InvoiceList';
// If invoices are already sent, let the user cancel them.
// If invoices are created buat not sent,
// APOLLO
import { graphql } from 'react-apollo';
import deleteInvoice from 'ApolloClient/Mutations/deleteInvoice';
import contractByIdQuery from 'ApolloClient/Queries/contractById';
import ErrorHelpers from 'lib/helpers/ErrorHelpers';

class AlreadyCreated extends React.PureComponent {
  state = {
    loading: false,
  };

  handleDelete = () => {
    message.success('cancel the invoices!');
  };

  getRefetchQueries = () => [
    {
      query: contractByIdQuery,
      variables: { _id: this.props.contract._id },
    },
  ];

  onCancelInvoice = async _id => {
    console.log(`onCancelInvoice ${_id}`);
    this.setState({ loading: true });

    let refetchQueries = this.getRefetchQueries();

    if (!_id) {
      return null;
    }

    let variables = { _id };
    let response;

    try {
      response = await this.props.deleteInvoice({
        variables,
        refetchQueries,
        update: (cache, { data }) => {
          console.log('==== update');
          const { contractById } = cache.readQuery({
            query: contractByIdQuery,
            variables: { _id: this.props.contract._id },
          });
          console.log(data.deleteInvoice);
          contractById.invoices = data.deleteInvoice.invoices;
          contractById.invoicesCreated = data.deleteInvoice.invoicesCreated;
          cache.writeQuery({
            query: contractByIdQuery,
            variables: { _id: this.props.contract._id },
            data: { contractById },
          });
          console.log('==== update');
        },
      });
    } catch (err) {
      this.setState({ loading: false });
      return ErrorHelpers.handleError(err);
    }

    this.setState({ loading: false });
  };

  render() {
    const { contract, currencySymbol } = this.props;

    if (this.state.loading) {
      return <div>deleting invoice...</div>;
    }

    if (contract.invoices[0].status === 'SENT') {
      return (
        <div>
          <div style={{ padding: 25, background: '#efefef' }}>
            <h2>You've already created and sent invoices for this contract.</h2>
            <h3>Do you want to cancel them? You can send a newer version after.</h3>
          </div>
          <InvoiceList
            header="We already sent the below invoice(s)"
            invoices={contract.invoices}
            onCancelInvoice={this.onCancelInvoice}
            depositAmount={contract.depositAmount}
            currencySymbol={currencySymbol}
            finalPaymentAmount={contract.finalPaymentAmount}
            finalPaymentDueDate={contract.finalPaymentDueDate}
            depositDueDate={contract.depositDueDate}
          />
        </div>
      );
    }

    return null;
  }
}

export default graphql(deleteInvoice, {
  name: 'deleteInvoice',
  // options: (props) => {
  //     return {
  //         refetchQueries: [{
  //             query: Contract.Query.refetchQueries, variables: props.conract._id
  //         }]
  //      }
  // }
})(AlreadyCreated);



// WEBPACK FOOTER //
// ./src/routes/contract-draft/InvoicesInfo/AlreadyCreated/index.js